






import { Vue, Prop, Component } from "vue-property-decorator";

@Component
export default class ImgView extends Vue {
  private show: boolean = true;
  @Prop() private src!: string;
  mounted() {
    this.$nextTick(() => {
      this.$el.scrollLeft = (this.$el.scrollWidth - this.$el.clientWidth) / 2;
    });
  }
}
